/*
 * FFFN variant picker helper (product page):
 *  1. auto-select the first in-stock size when the current pick is sold out
 *  2. contextually mark every option (size / colour / logo) as available or sold-out
 *     for the CURRENT selection, so picking a colour greys out the sizes that colour
 *     doesn't have (Horizon doesn't do this because Size is the first option).
 *
 * Data-driven from the product's /<handle>.js endpoint (the rendered DOM's option flags
 * are not colour-contextual, so they can't be trusted). Self-contained, no imports.
 * Listens on the bubbling 'variant:update' event Horizon fires after re-rendering the picker.
 * Scoped to the main product page; skips collection quick-add cards.
 */
(function () {
  'use strict';

  var DATA = null, loading = null, brk = { c: 0, ts: 0 };

  function picker() { return document.querySelector('variant-picker[data-template-product-match="true"]'); }

  function load(p) {
    if (DATA) return Promise.resolve(DATA);
    if (loading) return loading;
    var url = (p.getAttribute('data-product-url') || '').split('?')[0];
    if (!url) return Promise.resolve(null);
    loading = fetch(url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (prod) {
        if (!prod || !prod.variants) return null;
        DATA = {
          options: (prod.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; }),
          variants: prod.variants.map(function (v) { return { o: [v.option1, v.option2, v.option3], available: v.available }; })
        };
        return DATA;
      })
      .catch(function () { return null; });
    return loading;
  }

  function selections(p, data) {
    var sel = [];
    for (var k = 0; k < data.options.length; k++) sel.push(null);
    p.querySelectorAll('fieldset[data-fieldset-index]').forEach(function (fs) {
      var idx = parseInt(fs.getAttribute('data-fieldset-index'), 10);
      var c = fs.querySelector('input:checked');
      if (!isNaN(idx) && c) sel[idx] = c.value;
    });
    for (var i = 0; i < sel.length; i++) {
      if (sel[i] == null && data.variants[0]) sel[i] = data.variants[0].o[i];
    }
    return sel;
  }

  function exactVariant(data, sel) {
    return data.variants.find(function (v) {
      for (var i = 0; i < sel.length; i++) { if (sel[i] != null && v.o[i] !== sel[i]) return false; }
      return true;
    });
  }
  // any available variant matching the (partial) selection?
  function anyAvailable(data, sel) {
    return data.variants.some(function (v) {
      for (var i = 0; i < sel.length; i++) { if (sel[i] != null && v.o[i] !== sel[i]) return false; }
      return v.available;
    });
  }

  function colourIndex() {
    for (var k = 0; k < DATA.options.length; k++) { if (/colou?r/i.test(DATA.options[k])) return k; }
    return -1;
  }
  function matchScore(v, sel, colIdx) {
    var s = 0;
    for (var i = 0; i < sel.length; i++) { if (i === colIdx) continue; if (sel[i] != null && v.o[i] === sel[i]) s++; }
    return s;
  }

  // When the current combo is sold out, land on the first fully-available variant for the chosen
  // colour, changing as few of the other options (size / logo) as needed. Colour is the anchor
  // (the user's main pick) and is never auto-changed; if the whole colour is out, leave it greyed.
  function autoSelect(p) {
    if (!DATA) return false;
    var now = Date.now(); if (now - brk.ts > 2000) brk.c = 0; brk.ts = now; if (brk.c > 8) return false;
    var sel = selections(p, DATA);
    var cur = exactVariant(DATA, sel);
    if (cur && cur.available) return false;
    var colIdx = colourIndex();
    var cands = DATA.variants.filter(function (v) { return v.available && (colIdx < 0 || v.o[colIdx] === sel[colIdx]); });
    if (!cands.length) return false; // colour fully sold out — leave it marked, nothing to pick
    cands.sort(function (a, b) { return matchScore(b, sel, colIdx) - matchScore(a, sel, colIdx); });
    var target = cands[0];
    var fieldsets = p.querySelectorAll('fieldset[data-fieldset-index]');
    for (var f = 0; f < fieldsets.length; f++) {
      var idx = parseInt(fieldsets[f].getAttribute('data-fieldset-index'), 10);
      if (isNaN(idx) || idx === colIdx) continue;
      var want = target.o[idx];
      var checked = fieldsets[f].querySelector('input:checked');
      if (checked && checked.value === want) continue;
      var radios = fieldsets[f].querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === want) { brk.c++; radios[i].click(); return true; } // one change; convergence handles the rest
      }
    }
    return false;
  }

  // grey out option values with no in-stock variant. Colour swatches reflect whether the
  // colour is in stock AT ALL (so a rare selected size doesn't grey every colour). Size + logo
  // reflect availability for the currently chosen colour (+ other picks) = the "pick a colour,
  // see which sizes" filter seagey asked for.
  function markAvailability(p) {
    if (!DATA) return;
    var sel = selections(p, DATA);
    var colourIdx = -1;
    for (var k = 0; k < DATA.options.length; k++) { if (/colou?r/i.test(DATA.options[k])) { colourIdx = k; break; } }
    p.querySelectorAll('fieldset[data-fieldset-index]').forEach(function (fs) {
      var idx = parseInt(fs.getAttribute('data-fieldset-index'), 10);
      if (isNaN(idx)) return;
      var radios = fs.querySelectorAll('input[type="radio"]');
      for (var j = 0; j < radios.length; j++) {
        var r = radios[j];
        var cand;
        if (idx === colourIdx) { cand = []; for (var z = 0; z < DATA.options.length; z++) cand.push(null); cand[idx] = r.value; }
        else { cand = sel.slice(); cand[idx] = r.value; }
        var ok = anyAvailable(DATA, cand);
        var label = r.closest('label');
        if (ok) { r.setAttribute('data-option-available', 'true'); r.removeAttribute('aria-disabled'); if (label) label.classList.remove('fffn-soldout'); }
        else { r.setAttribute('data-option-available', 'false'); r.setAttribute('aria-disabled', 'true'); if (label) label.classList.add('fffn-soldout'); }
      }
    });
  }

  function run() {
    var p = picker();
    if (!p) return;
    load(p).then(function () {
      if (!DATA) return;
      if (p.closest('product-card') || p.closest('quick-add-dialog')) return;
      var moved = autoSelect(p);          // if it clicked, a re-render + new event will re-run us
      if (!moved) markAvailability(p);    // otherwise mark the current context now
    });
  }

  document.addEventListener('variant:update', run);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
